import React from 'react'
import { useTranslation } from 'react-i18next'
import { Linking, StyleSheet, View, ViewProps } from 'react-native'
import { Hyperlink, Spacing } from 'zens-storybook'
import { User } from 'zens-store'

import { InfoTable } from '../info'

const styles = StyleSheet.create({
  container: {
    marginBottom: Spacing.L,
  },
})

interface Props extends ViewProps {
  user: User
  companyId: number
}
const UserInfo = (props: Props) => {
  const { user, companyId, style, ...otherProps } = props
  const { t } = useTranslation()
  const mail = () => {
    Linking.openURL(`mailto:${user?.email}`)
  }
  const config = {
    fields: [
      {
        label: t('Name'),
        value: user.displayName,
      },
      {
        label: t('Email'),
        value: <Hyperlink title={user?.email} onPress={mail} testID="mail" />,
      },
      {
        label: t('Date created'),
        value: user.displayCreatedAt,
      },
    ],
  }

  return (
    <View style={[styles.container, style]} {...otherProps}>
      <InfoTable companyId={companyId} config={config} />
    </View>
  )
}

export default UserInfo
